import { MessagingBlock } from '@strata/react-messaging-block';
import Home from 'assets/home.svg?react';

export const NoLiveReferralsPage = () => (
    <div className="sds_fullscreen-page">
        <MessagingBlock
            className="sds_fullscreen-page__message-container"
            size={MessagingBlock.Sizes.LARGE}
            icon={<Home title="Home" />}
            primaryText="There are no referrals looking for a home right now."
            secondaryText="Please check back soon for Live Referrals."
        />
    </div>
);
